var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscrimination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8803 45.1769L45.4632 49.5939L70.4668 74.5975L74.8839 70.1804L49.8803 45.1769Z",
    fill: "#DC4D49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.18 27.6522C42.2278 27.6522 27.6522 42.2278 27.6522 60.18C27.6522 78.1322 42.2466 92.7078 60.18 92.7078C78.1134 92.7078 92.7078 78.1134 92.7078 60.18C92.7078 42.2466 78.1134 27.6522 60.18 27.6522ZM60.18 97.3412C39.6766 97.3412 23 80.6646 23 60.18C23 39.6954 39.6766 23 60.18 23C80.6834 23 97.36 39.6766 97.36 60.18C97.36 80.6834 80.6834 97.36 60.18 97.36",
    fill: "#DC4D49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4668 45.1768L45.4632 70.1804L49.8803 74.5975L74.8839 49.5939L70.4668 45.1768Z",
    fill: "#DC4D49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscrimination);
export default __webpack_public_path__ + "static/media/discrimination.c8f815334b263b3478f3f89fd4213070.svg";
export { ForwardRef as ReactComponent };